// Sơ đồ pha × kênh (owner chốt 2026-09-29, VTask#137 vòng 3, BẢN 2) — phần THUẦN, test ở tests/pha-kenh.test.ts.
// Trục của việc: nhãn `pha:<tên>` (9 pha, không đánh số — chèn pha sau này không lệch) + `kenh:<slug>` (30 kênh trong
// 7 nhóm). Mỗi KHỐI là một việc cụ thể ở một kênh trong một pha; loại khối Paid · Organic · Owned · Earned · Data lưu thành
// tag tự do `tag:<loại>` trên việc tạo từ khối gợi ý. Khối gợi ý: đọc từ hình owner gửi ("Sơ đồ 6 pha × 14 kênh"), gán
// lại vào 9 pha mịn hơn + các kênh G.Organic cần (YouTube, Google Maps, nhà thuốc & đại lý…).
import { boDau } from './nhan';

export const PHA = [
  { ma: 'nen-tang', ten: 'Nền tảng', mo_ta: 'Có sẵn trước khi khách tới: trang sản phẩm đúng claim, gian hàng, tracking, dữ liệu gốc, chính sách' },
  { ma: 'nhan-biet', ten: 'Nhận biết', mo_ta: 'Khách lần đầu thấy thương hiệu' },
  { ma: 'tim-hieu', ten: 'Tìm hiểu', mo_ta: 'Khách tự tìm thông tin: tìm kiếm, đọc trang sản phẩm, hỏi công cụ AI' },
  { ma: 'quan-tam', ten: 'Quan tâm', mo_ta: 'Khách tương tác, hỏi trực tiếp: inbox, bình luận, Zalo tư vấn' },
  { ma: 'so-sanh', ten: 'So sánh', mo_ta: 'Khách đặt thương hiệu cạnh đối thủ: review, so sánh giá / thành phần' },
  { ma: 'can-nhac', ten: 'Cân nhắc', mo_ta: 'Khách gần chọn xong, cần gỡ lo ngại cuối: ưu đãi, đổi trả, lời chứng' },
  { ma: 'mua', ten: 'Mua', mo_ta: 'Đặt hàng, thanh toán, giao hàng' },
  { ma: 'su-dung', ten: 'Sử dụng', mo_ta: 'Dùng sản phẩm: hướng dẫn, chăm sóc, đánh giá' },
  { ma: 'trung-thanh', ten: 'Trung thành', mo_ta: 'Mua lại, cộng đồng, giới thiệu bạn bè' },
] as const;
export type MaPha = (typeof PHA)[number]['ma'];
const SO_TRON = ['⓪', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'];
export const chiSoPha = (ma: string) => PHA.findIndex((p) => p.ma === ma);
export const tenPha = (ma: string) => PHA.find((p) => p.ma === ma)?.ten ?? ma;
export const nhanPha = (ma: string) => { const i = chiSoPha(ma); return i < 0 ? ma : `${SO_TRON[i]} ${PHA[i].ten}`; };

// 7 nhóm kênh — màu lấy từ token --nhom-<ma> / --nhom-<ma>-nhat (index.css, có bản tối).
export const NHOM_KENH = [
  { ma: 'lan-toa', ten: 'Lan toả', mo_ta: 'Người khác nói về thương hiệu' },
  { ma: 'mxh', ten: 'Mạng xã hội', mo_ta: 'Kênh mạng xã hội thương hiệu sở hữu' },
  { ma: 'quang-cao', ten: 'Quảng cáo trả phí', mo_ta: 'Trả tiền để được thấy' },
  { ma: 'tim-kiem', ten: 'Tìm kiếm & AI', mo_ta: 'Được tìm thấy khi khách tự tìm' },
  { ma: 'nhan-tin', ten: 'Nhắn tin & CRM', mo_ta: 'Nói chuyện 1-1, chăm sóc khách cũ' },
  { ma: 'diem-ban', ten: 'Điểm bán', mo_ta: 'Nơi khách đặt hàng' },
  { ma: 'du-lieu', ten: 'Dữ liệu', mo_ta: 'Tracking, đo lường, dữ liệu khách' },
] as const;
export type MaNhomKenh = (typeof NHOM_KENH)[number]['ma'];

export const KENH = [
  { ma: 'kol', ten: 'KOL', nhom: 'lan-toa' },
  { ma: 'koc', ten: 'KOC', nhom: 'lan-toa' },
  { ma: 'pr-bao-chi', ten: 'PR & báo chí', nhom: 'lan-toa' },
  { ma: 'review-ugc', ten: 'Review & UGC', nhom: 'lan-toa' },
  { ma: 'tiktok', ten: 'TikTok', nhom: 'mxh' },
  { ma: 'fanpage', ten: 'Fanpage', nhom: 'mxh' },
  { ma: 'facebook-group', ten: 'Facebook Group', nhom: 'mxh' },
  { ma: 'instagram', ten: 'Instagram', nhom: 'mxh' },
  { ma: 'youtube', ten: 'YouTube', nhom: 'mxh' },
  { ma: 'meta-ads', ten: 'Meta Ads', nhom: 'quang-cao' },
  { ma: 'tiktok-ads', ten: 'TikTok Ads', nhom: 'quang-cao' },
  { ma: 'google-ads', ten: 'Google Ads', nhom: 'quang-cao' },
  { ma: 'zalo-ads', ten: 'Zalo Ads', nhom: 'quang-cao' },
  { ma: 'openai-ads', ten: 'OpenAI Ads', nhom: 'quang-cao' },
  { ma: 'san-ads', ten: 'Quảng cáo sàn', nhom: 'quang-cao' },
  { ma: 'seo', ten: 'SEO', nhom: 'tim-kiem' },
  { ma: 'aeo', ten: 'AEO', nhom: 'tim-kiem' },
  { ma: 'geo', ten: 'GEO', nhom: 'tim-kiem' },
  { ma: 'google-maps', ten: 'Google Maps', nhom: 'tim-kiem' },
  { ma: 'zalo-oa', ten: 'Zalo OA', nhom: 'nhan-tin' },
  { ma: 'zalo-ca-nhan', ten: 'Zalo cá nhân', nhom: 'nhan-tin' },
  { ma: 'zalo-mini-app', ten: 'Zalo Mini App', nhom: 'nhan-tin' },
  { ma: 'zalo-zns', ten: 'Zalo ZNS', nhom: 'nhan-tin' },
  { ma: 'email-sms', ten: 'Email & SMS', nhom: 'nhan-tin' },
  { ma: 'website', ten: 'Website', nhom: 'diem-ban' },
  { ma: 'shopee', ten: 'Shopee', nhom: 'diem-ban' },
  { ma: 'tiktok-shop', ten: 'TikTok Shop', nhom: 'diem-ban' },
  { ma: 'lazada', ten: 'Lazada', nhom: 'diem-ban' },
  { ma: 'nha-thuoc-dai-ly', ten: 'Nhà thuốc & đại lý', nhom: 'diem-ban' },
  { ma: 'du-lieu', ten: 'Dữ liệu & đo lường', nhom: 'du-lieu' },
] as const satisfies readonly { ma: string; ten: string; nhom: MaNhomKenh }[];
export type MaKenh = (typeof KENH)[number]['ma'];
export const tenKenh = (ma: string) => KENH.find((k) => k.ma === ma)?.ten ?? ma;
export const nhomCuaKenh = (ma: string): MaNhomKenh | null => KENH.find((k) => k.ma === ma)?.nhom ?? null;
export const tenNhomKenh = (ma: string) => NHOM_KENH.find((n) => n.ma === ma)?.ten ?? ma;

// Tài sản thương hiệu (checklist) → kênh của sơ đồ. Trường `kenh` của mục hành trình có thể là slug TÀI SẢN (dữ liệu cũ)
// hoặc slug KÊNH (dữ liệu mới) — kenhCua() nhận cả hai. Tài sản nội bộ (SaleKit, tư vấn, bảng giá, claim…) → [].
export const KENH_CUA_TAI_SAN: Record<string, MaKenh[]> = {
  website: ['website'], facebook: ['fanpage'], 'facebook-group': ['facebook-group'], 'zalo-oa': ['zalo-oa'], youtube: ['youtube'],
  tiktok: ['tiktok'], instagram: ['instagram'], shopee: ['shopee'], 'tiktok-shop': ['tiktok-shop'],
  'quang-cao': ['meta-ads', 'tiktok-ads', 'google-ads'], 'koc-ugc': ['koc', 'review-ugc'], 'pr-bao-chi': ['pr-bao-chi'],
  'dai-ly': ['nha-thuoc-dai-ly'], 'do-luong': ['du-lieu'], 'google-maps': ['google-maps'], livestream: ['tiktok', 'fanpage'],
  'email-crm': ['email-sms'],
};
export function kenhCua(gia_tri: string): MaKenh[] {
  if (KENH.some((k) => k.ma === gia_tri)) return [gia_tri as MaKenh];
  return KENH_CUA_TAI_SAN[gia_tri] ?? [];
}
// Bước hành trình (tài sản nhóm hanh-trinh ở trang Tài sản) ↔ pha.
export const PHA_CUA_HANH_TRINH: Record<string, MaPha> = {
  'nen-tang': 'nen-tang', 'nhan-biet': 'nhan-biet', 'tim-hieu': 'tim-hieu', 'quan-tam': 'quan-tam', 'so-sanh': 'so-sanh',
  'can-nhac': 'can-nhac', 'mua-hang': 'mua', 'su-dung': 'su-dung', 'trung-thanh': 'trung-thanh',
};

export const LOAI_KHOI = [
  { ma: 'paid', ten: 'Paid', mo_ta: 'trả phí' },
  { ma: 'organic', ten: 'Organic', mo_ta: 'tự nhiên' },
  { ma: 'owned', ten: 'Owned', mo_ta: 'kênh sở hữu' },
  { ma: 'earned', ten: 'Earned', mo_ta: 'kênh lan toả' },
  { ma: 'data', ten: 'Data', mo_ta: 'dữ liệu' },
] as const;
export type LoaiKhoi = (typeof LOAI_KHOI)[number]['ma'];
export const loaiCuaTags = (tags: string[]): LoaiKhoi | null => (LOAI_KHOI.find((l) => tags.includes(l.ma))?.ma ?? null);

// 6 loại liên kết giữa khối (như hình): màu + nét lấy từ token có sẵn (đỏ, cam, lục, tím trạng thái, chữ phụ).
export const LOAI_LIEN_KET = [
  { ma: 'tep-khan-gia', ten: 'Tệp khán giả chuyển tiếp', mau: 'var(--do)', net: '' },
  { ma: 'luong-khach', ten: 'Luồng khách', mau: 'var(--cam)', net: '' },
  { ma: 'noi-dung', ten: 'Nội dung dùng lại', mau: 'var(--do)', net: '6 4' },
  { ma: 'du-lieu', ten: 'Dữ liệu, insight', mau: 'var(--chu-phu)', net: '2 3' },
  { ma: 'bang-chung', ten: 'Bằng chứng xã hội', mau: 'var(--luc)', net: '' },
  { ma: 'vong-lap', ten: 'Vòng lặp về pha trước', mau: 'var(--tt-cho-duyet)', net: '2 3' },
] as const;
export type LoaiLienKet = (typeof LOAI_LIEN_KET)[number]['ma'];

export interface KhoiMau { pha: MaPha; kenh: MaKenh; ten: string; loai: LoaiKhoi }
const k = (pha: MaPha, kenh: MaKenh, loai: LoaiKhoi, ten: string): KhoiMau => ({ pha, kenh, ten, loai });
export const KHOI_MAU: KhoiMau[] = [
  // ⓪ Nền tảng
  k('nen-tang', 'koc', 'owned', 'Claim + hợp đồng KOC'),
  k('nen-tang', 'website', 'owned', 'Website: sản phẩm + FAQ'),
  k('nen-tang', 'shopee', 'owned', 'Gian hàng Shopee Mall'),
  k('nen-tang', 'tiktok-shop', 'owned', 'Mở gian hàng TikTok Shop'),
  k('nen-tang', 'lazada', 'owned', 'Gian hàng LazMall'),
  k('nen-tang', 'google-maps', 'owned', 'Hồ sơ Google Maps đúng NAP'),
  k('nen-tang', 'zalo-oa', 'owned', 'Zalo OA xác thực doanh nghiệp'),
  k('nen-tang', 'nha-thuoc-dai-ly', 'owned', 'Chính sách đại lý + bảng giá sỉ'),
  k('nen-tang', 'du-lieu', 'data', 'Tracking có đồng ý'),
  k('nen-tang', 'du-lieu', 'data', 'Dữ liệu sản phẩm gốc'),
  // ① Nhận biết
  k('nhan-biet', 'kol', 'paid', 'KOL video'),
  k('nhan-biet', 'koc', 'paid', 'KOC video'),
  k('nhan-biet', 'pr-bao-chi', 'earned', 'Báo chí, blog ngành'),
  k('nhan-biet', 'tiktok', 'owned', 'Kênh TikTok thương hiệu'),
  k('nhan-biet', 'tiktok-ads', 'paid', 'TikTok Ads'),
  k('nhan-biet', 'meta-ads', 'paid', 'Meta Ads'),
  k('nhan-biet', 'fanpage', 'owned', 'Fanpage: bài đăng, Reels'),
  k('nhan-biet', 'instagram', 'owned', 'Instagram Reels, collab'),
  k('nhan-biet', 'google-ads', 'paid', 'YouTube Ads'),
  k('nhan-biet', 'youtube', 'owned', 'YouTube Shorts'),
  k('nhan-biet', 'seo', 'organic', 'SEO: bài thông tin'),
  // ② Tìm hiểu
  k('tim-hieu', 'tiktok-ads', 'paid', 'TikTok Search Ads'),
  k('tim-hieu', 'google-ads', 'paid', 'Google Search Ads'),
  k('tim-hieu', 'seo', 'organic', 'SEO: trang sản phẩm, danh mục'),
  k('tim-hieu', 'aeo', 'organic', 'AEO: đoạn trích, PAA'),
  k('tim-hieu', 'geo', 'organic', 'GEO: ChatGPT, Gemini'),
  k('tim-hieu', 'openai-ads', 'paid', 'OpenAI Ads'),
  k('tim-hieu', 'youtube', 'owned', 'Video hướng dẫn pha'),
  k('tim-hieu', 'website', 'owned', 'Trang thành phần + cách dùng'),
  // ③ Quan tâm
  k('quan-tam', 'fanpage', 'owned', 'Fanpage: Messenger, bình luận'),
  k('quan-tam', 'tiktok', 'owned', 'Trả lời bình luận bằng video'),
  k('quan-tam', 'facebook-group', 'owned', 'Nhóm hỏi đáp ăn đủ rau'),
  k('quan-tam', 'meta-ads', 'paid', 'Meta Ads tương tác lại'),
  k('quan-tam', 'zalo-oa', 'owned', 'Zalo OA tư vấn'),
  k('quan-tam', 'zalo-ca-nhan', 'owned', 'Zalo cá nhân tư vấn'),
  k('quan-tam', 'nha-thuoc-dai-ly', 'owned', 'Tư vấn tại quầy'),
  // ④ So sánh
  k('so-sanh', 'koc', 'earned', 'KOC affiliate'),
  k('so-sanh', 'review-ugc', 'earned', 'Review sản phẩm thật'),
  k('so-sanh', 'seo', 'organic', 'SEO: trang so sánh, review'),
  k('so-sanh', 'aeo', 'organic', 'AEO: câu trả lời so sánh'),
  k('so-sanh', 'geo', 'organic', 'GEO so sánh'),
  k('so-sanh', 'san-ads', 'paid', 'Shopee Ads'),
  k('so-sanh', 'website', 'owned', 'Bảng so sánh giá theo gram'),
  // ⑤ Cân nhắc
  k('can-nhac', 'instagram', 'owned', 'Instagram Story, link in bio'),
  k('can-nhac', 'meta-ads', 'paid', 'Meta Ads remarketing'),
  k('can-nhac', 'tiktok-ads', 'paid', 'TikTok Ads remarketing'),
  k('can-nhac', 'google-ads', 'paid', 'Google remarketing'),
  k('can-nhac', 'zalo-ads', 'paid', 'Zalo Ads'),
  k('can-nhac', 'openai-ads', 'paid', 'OpenAI Ads'),
  k('can-nhac', 'website', 'owned', 'Chính sách đổi trả, cam kết'),
  // ⑥ Mua
  k('mua', 'tiktok', 'owned', 'Livestream TikTok'),
  k('mua', 'fanpage', 'owned', 'Fanpage livestream'),
  k('mua', 'meta-ads', 'paid', 'Meta CPAS'),
  k('mua', 'google-ads', 'paid', 'Performance Max, Shopping'),
  k('mua', 'openai-ads', 'paid', 'OpenAI Ads Conversions'),
  k('mua', 'san-ads', 'paid', 'TikTok Shop Ads'),
  k('mua', 'aeo', 'organic', 'AEO: mua ở đâu, đổi trả'),
  k('mua', 'zalo-mini-app', 'owned', 'Zalo Mini App'),
  k('mua', 'zalo-ca-nhan', 'owned', 'Chốt đơn qua Zalo cá nhân'),
  k('mua', 'website', 'owned', 'Website (trang mua)'),
  k('mua', 'shopee', 'owned', 'Shopee Mall: chốt đơn'),
  k('mua', 'tiktok-shop', 'owned', 'Gian hàng TikTok Shop'),
  k('mua', 'lazada', 'owned', 'LazMall'),
  k('mua', 'nha-thuoc-dai-ly', 'owned', 'Điểm bán đúng giá'),
  // ⑦ Sử dụng
  k('su-dung', 'review-ugc', 'earned', 'Xin đánh giá sau mua'),
  k('su-dung', 'youtube', 'owned', 'Video công thức, mẹo dùng'),
  k('su-dung', 'zalo-zns', 'owned', 'Zalo ZNS hướng dẫn dùng'),
  k('su-dung', 'email-sms', 'owned', 'Email, SMS sau mua'),
  k('su-dung', 'website', 'owned', 'Trang tra mã lô'),
  k('su-dung', 'du-lieu', 'data', 'Dữ liệu người mua'),
  // ⑧ Trung thành
  k('trung-thanh', 'review-ugc', 'earned', 'Review, UGC giới thiệu bạn bè'),
  k('trung-thanh', 'facebook-group', 'owned', 'Nhóm cộng đồng khách'),
  k('trung-thanh', 'tiktok-ads', 'paid', 'TikTok Ads mua lại'),
  k('trung-thanh', 'meta-ads', 'paid', 'Meta Ads mua lại'),
  k('trung-thanh', 'zalo-oa', 'owned', 'Zalo OA nhắc mua lại'),
  k('trung-thanh', 'email-sms', 'owned', 'Chương trình khách thân thiết'),
  k('trung-thanh', 'nha-thuoc-dai-ly', 'owned', 'Tái đặt hàng đại lý'),
  k('trung-thanh', 'du-lieu', 'data', 'Đo phần tăng thêm'),
];

// Khối gợi ý đã "có việc" khi trong cùng ô có việc mang tag = slug của khối, hoặc tiêu đề chứa tên khối (bỏ dấu, không
// phân biệt hoa thường). Việc tạo từ khối gợi ý luôn mang tag slug khối nên chắc chắn khớp.
export const slugKhoi = (ten: string) => boDau(ten).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
export function khoiDaCo(khoi: KhoiMau, viec_o: { tieu_de: string; tags: string[] }[]): boolean {
  const s = slugKhoi(khoi.ten);
  const ten = boDau(khoi.ten).toLowerCase();
  return viec_o.some((v) => v.tags.includes(s) || boDau(v.tieu_de).toLowerCase().includes(ten));
}

// Tiến độ một nhóm việc: xong / tổng (không tính mục tiêu), số mở, số trễ. pt null khi chưa có việc.
export function tienDoViec(ds: { mo: boolean; tre: boolean }[]) {
  const xong = ds.filter((v) => !v.mo).length;
  return { tong: ds.length, xong, mo: ds.length - xong, tre: ds.filter((v) => v.mo && v.tre).length, pt: ds.length ? Math.round((xong * 100) / ds.length) : null };
}
